module.exports = __webpack_public_path__ + "img/background20.9da53b9d.jpg";